// **  Initial State
const initialState = {}

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "HANDLE_DASHBOARD":
      return { ...state, ...action.value }
    case "HANDLE_CREDITS_COUNT":
      return { ...state, stimulus_count: {...state.stimulus_count, count: action.value} }
    case 'LOGOUT':
      return {}
    default:
      return state
  }
}

export default dashboardReducer
